import Box from '@eversports/klimt-primitives/legacy/Box'
import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Link from '@eversports/klimt-primitives/legacy/Link'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import { Helmet } from 'react-helmet-async'

import useGetTopContentHeight from '../../hooks/useGetTopContentHeight'
import { Localized, useIntl } from '../../localization/react'

const DataSubProcessors = () => {
  const intl = useIntl()
  const { DESKTOP_TOP_CONTENT_HEIGHT: TOP_CONTENT_HEIGHT } = useGetTopContentHeight(['NAVIGATION_BAR'])
  const pdfUrl = `/cdn/data-subprocessors.pdf`

  return (
    <>
      <Helmet>
        <title>{`Eversports - ${intl.dataSubProcessorsHeading()}`}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'eggshell',
        }}
      >
        <Stack
          sx={{
            height: `calc(100vh - ${TOP_CONTENT_HEIGHT}px)`,
            gap: 8,
            maxWidth: 1280,
            width: '100%',
            margin: '0 auto',
            paddingTop: 12,
          }}
          component="main"
        >
          <Heading is="h1">
            <Localized id="data-sub-processors-heading" />
          </Heading>
          <Link to={pdfUrl} external>
            {intl.dataSubProcessorsAccessibleLink()}
          </Link>
          <object data={pdfUrl} type="application/pdf" width="100%" height="100%" aria-hidden="true">
            <iframe
              title={intl.dataSubProcessorsIframeTitle()}
              src={`https://docs.google.com/gview?url=${pdfUrl}&embedded=true`}
              width="100%"
              height="100%"
            />
          </object>
        </Stack>
      </Box>
    </>
  )
}

export default DataSubProcessors
